"use client";

import React from "react";
import Gallery from "rivals/components/pages/Article/Blocks/GalleryBlock";
import useGetCurrentUser from "rivals/services/getCurrentUser/useGetCurrentUser";
import useGetGallery from "rivals/services/getGallery/useGetGallery";
import { AthleteViews } from "rivals/shared/interfaces/Athlete";
import { Props } from "./types";

export default function GalleryBlockContainer({
  id
}: Props): React.JSX.Element {
  const { data, error } = useGetGallery({ galleryId: id });
  const { data: user } = useGetCurrentUser();
  const gallery = data?.gallery;
  const isSubscribedUser = !!user?.user?.subscriptions?.length;

  return (
    <Gallery
      activeAthleteView={AthleteViews.COLLEGE_PLAYER_VIEW}
      animatedDescription={false}
      error={error}
      gallery={gallery}
      galleryDetails={gallery}
      isSubscribedUser={isSubscribedUser}
    />
  );
}
